var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-wrapper",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}},[_c('div',{staticClass:"modal",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("header"),_vm._t("main"),_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }